import toast from "react-hot-toast";

export default (error: any) => {
  toast.error('Request failed , endpoint not found', {
    position: 'top-left',
    duration: 5000,
  });
}